import { render, staticRenderFns } from "./points_task_join.vue?vue&type=template&id=db1c4e94&scoped=true"
import script from "./points_task_join.vue?vue&type=script&lang=js"
export * from "./points_task_join.vue?vue&type=script&lang=js"
import style0 from "./points_task_join.vue?vue&type=style&index=0&id=db1c4e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1c4e94",
  null
  
)

export default component.exports